const SHARE_BINDING_STATUS = {
    UN_LINK: 'UN_LINK',
    LINKED: 'LINKED',
    LINKING: 'LINKING',
};

const SHARE_STATE = {
    SHARE_IDLE: 'IDLE',
    SHARING: 'SHARING',
    WAIT_SHARE: 'WAIT_SHARE',
    SHARE_SUCCESS: 'SHARE_SUCCESS',
    SHARE_FAIL: 'SHARE_FAIL',
};

const ACCESS_TOKEN_STATUS = {
    INVALID: 'INVALID',
    VALID: 'VALID',
    WAIT_CHECK: 'WAIT_CHECK',
};

const SOCIAL_KEY = {
    GOOGLE_DRIVE: 'googleDrive',
    FACEBOOK: 'facebook',
    TWITTER: 'twitter',
    INSTAGRAM: 'instagram',
    YOUTUBE: 'youtube',
    TIKTOK: 'tiktok',
    LINKEDIN: 'linkedin',
};

interface SOCIAL_ITEM {
    linkAccountState: (typeof SHARE_BINDING_STATUS)[keyof typeof SHARE_BINDING_STATUS];
    accessTokenState: (typeof ACCESS_TOKEN_STATUS)[keyof typeof ACCESS_TOKEN_STATUS];
    shareState: (typeof SHARE_STATE)[keyof typeof SHARE_STATE];
    shareType: string;
    email: string;
    name: string;
    avatar: string;
}

export type { SOCIAL_ITEM };
export { SHARE_BINDING_STATUS, SHARE_STATE, ACCESS_TOKEN_STATUS, SOCIAL_KEY };
